var exports = {
  "kL": "FriendSelector.module__container___aTJadX",
  "hJ": "FriendSelector.module__searchField___aTJadX",
  "lA": "FriendSelector.module__searchFieldInner___aTJadX",
  "t$": "FriendSelector.module__selectedPill___aTJadX",
  "DT": "FriendSelector.module__removeButton___aTJadX",
  "qc": "FriendSelector.module__searchIcon___aTJadX",
  "D3": "FriendSelector.module__searchIconFocused___aTJadX",
  "Rt": "FriendSelector.module__searchInput___aTJadX",
  "XG": "FriendSelector.module__scroller___aTJadX",
  "yY": "FriendSelector.module__scrollerNoSearch___aTJadX",
  "p$": "FriendSelector.module__emptyState___aTJadX",
  "q6": "FriendSelector.module__emptyStateText___aTJadX",
  "_s": "FriendSelector.module__groupsContainer___aTJadX",
  "cp": "FriendSelector.module__groupLetter___aTJadX",
  "QS": "FriendSelector.module__friendsList___aTJadX",
  "jZ": "FriendSelector.module__friendButton___aTJadX",
  "An": "FriendSelector.module__friendButtonSelected___aTJadX",
  "FI": "FriendSelector.module__friendButtonDisabled___aTJadX",
  "Hb": "FriendSelector.module__friendInfo___aTJadX",
  "G3": "FriendSelector.module__friendName___aTJadX",
  "HI": "FriendSelector.module__checkboxContainer___aTJadX",
  "Yz": "FriendSelector.module__removeIcon___aTJadX",
};

module.exports = exports;
